import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import Tab from './Tab';

const TabBar = (props) => {
    const classes = useStyles();
    const [currentTab, setCurrentTab] = useState(props.default);

    const handleTabChange = (event, newValue) => {
        setCurrentTab(newValue);
    };

    useEffect(() => {
        let tabName = props.location.pathname.split('/')[props.hierarchy]
        let newTab = tabName ? tabName : props.default
        if(currentTab !== newTab){
            setCurrentTab(newTab);
        }
    }, [props.location.pathname, props.default, props.hierarchy, currentTab])

    return (
        <div className={`${classes.TabBar} tabBar`}>
            <Tabs
                variant="scrollable"
                scrollButtons="auto"
                aria-label="scrollable auto tabs example"
                value={currentTab}
                onChange={handleTabChange}
                indicatorColor="primary"
                textColor="primary"
            >
                    {props.tabs.map(tab => (
                        <Tab
                            key={tab.value}
                            value={tab.value}
                            label={tab.label}
                            linkto={tab.linkto}
                        />
                    ))}
            </Tabs>
        </div>
    );
}

export default withRouter(TabBar);

const useStyles = makeStyles((theme) => ({
    TabBar: {
        position: 'relative',
        display: "flex",
        justifyContent: "center",
        borderTop: "solid 1px rgba(0, 0, 0, 0.1)",
        boxShadow: "0 6px 6px rgba(0, 0, 0, 0.1)",
        minHeight: "initial",
        backgroundColor: theme.palette.background.paper,
        "&:after": {
            content: "''",
            position: 'absolute',
            width: '30px',
            height: '100%',
            background: `linear-gradient(90deg, ${theme.palette.background.paper}00 0%, ${theme.palette.background.paper} 70%)`,
            top: 0,
            right: 0,
        }
    }
}));
